<template>
<div>
    <modal v-model="contractModal" :title="titleContractModal" @hide="resetContractModal">
        <div class="row">
            <div class="col-lg-4">
                <div class="form-group">
                    <label class="control-label">Código</label>
                    <input type="number" class="form-control" v-model="contract.code">
                </div>
            </div>
        </div>

        <div slot="footer">
            <btn @click="dentalPlanModal=false">Cancelar</btn>
            <btn type="primary" @click="saveContract"><i class="fa fa-save" aria-hidden="true"></i> {{contractActionModalTextButton}}</btn>
        </div>
    </modal>

    <div class="row">
        <div class="col-md-12">
            <div class="box box-default">
                <div class="box-header with-border">
                    <i class="fa fa-stethoscope"></i>
                    <h3 class="box-title">Contratos</h3><btn type="primary" @click="handleContract" class="pull-right">Novo contrato</btn>
                </div>
                <div class="box-body">
                    <datatable-component search-placeholder-prop="Buscar..." ref="dataTables" class="mt-3"
                                            :columns-prop="columns"
                                            url-prop="/getAll/byPatient"
                                            :tableDataSendRequestProp="{patient_id: this.contract.patient_id}"
                                            default-order-prop="code">
                        <template v-slot:price_list="data">
                            {{ data.data.price_list ? data.data.price_list.code + ' | ' + data.data.price_list.name : 'TABELA MODELO | PARTICULAR' }}
                        </template>
                        <template v-slot:action="data">
                            <li class="m-1" @click="editContract(data.data)"><a href="javascript:void(0)" title="Editar"><i class="fa fa-edit" aria-hidden="true"></i> Alterar</a></li>
                            <li class="m-1"><a :href="`/contract/${data.data.id}`" target="_blank" title="Imprimir"><i class="fa fa-print" aria-hidden="true"></i> Imprimir</a></li>
                            <li class="m-1" @click="deleteContract(data.data)"><a href="javascript:void(0)" title="Excluir"><i class="fa fa-trash" aria-hidden="true"></i> Excluir</a></li>
                        </template>
                    </datatable-component>
                </div>
            </div>
        </div>
    </div>
</div>

</template>

<script>
    import DatatableComponent from "../../datatable/datatable-component";

    export default {
        name: "PatientContracts",

        components: { DatatableComponent },

        props: {
            patientProp: { type: Object },
        },

        data() {
            return {
                optionsToast: { timeout: 6000, position: 'topCenter' },

                contractModal: false,
                titleContractModal: null,
                contractActionModalTextButton: null,
                columns:[
                    { width: '95%', label: 'CÓDIGO.', name: 'code', type: 'String', sortable: true },
                    { width: '5%', label: 'AÇÃO', name: 'action', type: 'action', sortable: false },
                ],

                contract: {
                    id: null,
                    code: null,
                    patient_id: this.patientProp.id,
                }
            }
        },

        methods: {
            handleContract(){
                this.titleContractModal = 'Criar contrato'
                this.contractActionModalTextButton = 'Criar contrato'
                this.contractModal = true
            },

            editContract(data){
                this.titleContractModal = 'Alterar contrato'
                this.contractActionModalTextButton = 'Alterar contrato'
                this.contract.id = data.id
                this.contract.code = data.code
                this.contractModal = true
            },

            async saveContract(){
                // if (this.$v.$invalid) {
                //     this.$toast.warning('Por favor revise os campos obrigatórios', 'Aviso', this.optionsToast);
                //     return false
                // }

                try {
                    this.contractModal = false
                    let response = {}
                    if(this.contract.id)
                        response = await axios.put('/contract',this.contract);
                    else
                        response = await axios.post('/contract',this.contract);

                    if(response.data.type == 'success'){
                        this.$refs.dataTables.reload()
                        this.$toast.success(response.data.message, response.data.title, this.optionsToast);
                    } else if(response.data.type == 'warning'){
                        this.$toast.warning(response.data.message, response.data.title, this.optionsToast);
                    } else {
                        this.$toast.info(response.data.message, response.data.title, this.optionsToast);
                    }
                } catch (error) {
                    console.log(error);
                    if(error.response.status === 401 || error.response.status === 419){
                        this.$toast.warning('Sua sessão expirou. Por favor atualize a página.', 'AVISO', this.optionsToast);
                    } else {
                        this.$toast.error(error.response.data.message, 'Erro', this.optionsToast);
                    }
                }
            },

            deleteContract(data) {
                let self = this;
                this.$toast.question('Tem certeza que deseja excluir este contrato?<br>Esta operação é irreversível!','ATENÇÃO',{
                    timeout: 20000,
                    close: false,
                    overlay: true,
                    toastOnce: true,
                    id: 'delete_contract_' + data.id,
                    position: "center",
                    buttons: [
                        [
                            "<button><b>DELETAR CONTRATO</b></button>",
                            function(instance, toast) {
                                instance.hide({ transitionOut: "fadeOut" }, toast);
                                axios.delete('/contract/' + data.id)
                                    .then(response => {
                                        if(response.data.type == 'success'){
                                            self.$refs.dataTables.reload();
                                            self.$toast.success(response.data.message, response.data.title, self.optionsToast);
                                        } else if(response.data.type == 'warning'){
                                            self.$toast.warning(response.data.message, response.data.title, self.optionsToast);
                                        } else {
                                            self.$toast.info(response.data.message, response.data.title, self.optionsToast);
                                        }
                                    }).catch(error => {
                                    console.log(error);
                                    if(error.response.status === 401 || error.response.status === 419){
                                        self.$toast.warning('Sua sessão expirou. Por favor atualize a página.', 'AVISO', self.optionsToast);
                                    } else {
                                        self.$toast.error(error.response.data.message, 'Erro', self.optionsToast);
                                    }
                                })
                            },
                            true
                        ],
                        [
                            "<button>CANCELAR</button>",
                            function(instance, toast) {
                                instance.hide({ transitionOut: "fadeOut" }, toast);
                            }
                        ]
                    ],
                })
            },

            resetContractModal(){
                this.contract.id = null
                this.contract.code = null
            }
        }
    }
</script>

<style>

</style>